import { useIntl } from 'react-intl'
import { IReportTicket } from '../ReportsPage.types'
import { PayoutTokenLink } from '../../../common/PayoutTokenLink'
import { convertUTCtoMSK, formatSum } from '../../../../utils'
import { ROLE, useAuth } from '../../auth'
import { IsGranted } from '../../auth/PrivateRoute'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import InfoHint from '../../../common/InfoHint'
import { ClientCell } from '../../../common/ClientCell'
import { PayoutAmountMode } from '../core/types'
import { DepositTokenLink } from '../../../common/DepositTokenLink'

const ReportTicketItem = ({
  ticket,
  ticketType,
  amountMode,
}: {
  ticket: IReportTicket
  ticketType?: string
  /** Только для выплат: какую из двух сумм строки показать в колонке суммы. */
  amountMode?: PayoutAmountMode
}) => {
  const intl = useIntl()
  const { currentUser } = useAuth()

  // console.log(ticket);

  // Строка выплаты несёт обе суммы, режим выбирает поле. В режиме запроса у всех строк одна
  // и та же сумма — запрошенная, без «серой» подмены: подменять нечего.
  // В режиме факта у отменённой выплаты фактическая сумма всегда 0 — показываем запрошенную серым.
  const renderAmount = () => {
    if (ticketType !== 'payout') {
      return ticket.amount ? formatSum(ticket.amount) : '-'
    }

    if (amountMode === 'REQUESTED') {
      const requested = Number(ticket.requestedAmount)

      return Number.isFinite(requested) && requested > 0 ? formatSum(requested) : '-'
    }

    const actualAmount = Number(ticket.amount)
    if (Number.isFinite(actualAmount) && actualAmount > 0) {
      return formatSum(actualAmount)
    }

    const requestedAmount = Number(ticket.requestedAmount)
    if (Number.isFinite(requestedAmount) && requestedAmount > 0) {
      return (
        <span className='text-muted' title='Запрошенная сумма'>
          {formatSum(requestedAmount)}
        </span>
      )
    }

    return '-'
  }

  return (
    <tr>
      <td>
        {ticketType === 'payout' ? (
          <PayoutTokenLink token={ticket.token} />
        ) : (
          <DepositTokenLink token={ticket.token} />
        )}
      </td>
      <td>{ticket.platformTransactionId || '-'}</td>
      <td>{ticket.createdDate ? convertUTCtoMSK(ticket.createdDate) : ''}</td>
      <td>{ticket.completedDate ? convertUTCtoMSK(ticket.completedDate) : ''}</td>
      {ticketType === 'payment' && (
        <td>
          <span className='badge'>{ticket.paymentMethod ? ticket.paymentMethod : '-'}</span>
        </td>
      )}
      <td>{renderAmount()}</td>
      {ticketType === 'payment' &&
        IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_CASHIER], currentUser) && (
          <td>{ticket.smsText ? ticket.smsText : 'смс не поступило'}</td>
        )}
      <ClientCell externalId={ticket.externalUserId} token={ticket.clientToken} />
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) && (
        <td>
          {/* пополнения отдают externalUserFlag, выплаты — color */}
          {(ticket.externalUserFlag || ticket.color) ? (
            <img
              src={toAbsoluteUrl(`/media/flags/${ticket.externalUserFlag || ticket.color}.svg`)}
              alt=''
              className='w-30px'
            />
          ) : (
            '-'
          )}
        </td>
      )}
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) && (
        <td>{ticket.merchant}</td>
      )}
      {IsGranted(
        [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER],
        currentUser
      ) && <td>{ticket.cashbox}</td>}
      <td>
        {intl.formatMessage({ id: `ticket.status.${ticket.status}` })}
        <InfoHint text={ticket.closeReasonTitle || undefined} />
      </td>
      {ticketType === 'payout' &&
        IsGranted(
          [ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_CASHIER, ROLE.ROLE_SENIOR_CASHIER, ROLE.ROLE_MERCHANT_MANAGER],
          currentUser
        ) && <td className='w-150px'>{ticket.commission}</td>}
    </tr>
  )
}

export default ReportTicketItem
